// A person moving an order off Project Requested while there is no footage the portal can pull (backend
// app/hand_move.py; Ryan, 2026-10-12). The server refuses the move with 409 and
// { code: 'nothing_to_pull', kind, message, can_override }: the words say what to do instead. Admin alone may make the
// move anyway, and only after being asked here; the same request is then sent again with `force: true`.
// Three places change an admin status (the drawer's select, the board's row, the board's bulk bar): each reads the
// refusal through `stopOf`, so none of them can answer it with a bare "Failed".
export const CODE = 'nothing_to_pull';

// The refusal out of a failed status change, or null when it failed for any other reason.
export function stopOf(error) {
  const d = error?.response?.data?.detail;
  if (error?.response?.status !== 409 || !d || typeof d !== 'object' || d.code !== CODE) return null;
  if (typeof d.message !== 'string' || !d.message) return null;
  return { message: d.message, canOverride: d.can_override === true };
}

// What admin is asked before the move is made anyway (the confirm box: components/ConfirmDialog.js).
export const ASK_TITLE = 'Move it anyway?';
export const ASK_YES = 'Move it anyway';
export const ASK_NO = 'Leave it here';
export function askWords(stop) {
  return `${stop.message} Moving it now does not get the footage to anyone.`;
}

// A bulk change: what to say of the projects that stayed where they were. No override from the bulk bar: a project
// that needs one is opened and moved on its own, where the reason is read.
export function bulkWords(stayed, stop) {
  const n = stayed === 1 ? '1 project was not moved' : `${stayed} projects were not moved`;
  return `${n}. ${stop.message}`;
}
